var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-app',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3"},[_c('m-input',{attrs:{"label":"Adı"}}),_c('m-select',{attrs:{"label":"Seç"}}),_c('m-input-btn',{attrs:{"label":"Seç"}}),_c('m-textarea',{attrs:{"label":"Yaz"}}),_c('m-yes-no',{attrs:{"label":"Yaz"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }